module.exports = __webpack_public_path__ + "static/Ruslan-hidden-017b60e4d274bb8ed99105ba855e4759.jpg";